import React, { useRef, useLayoutEffect } from "react";
import styled, { StyleSheetManager } from "styled-components";
import { Grommet } from "grommet";
import GlobalStyles from "../GlobalStyles/GlobalStyles";
import theme, { color } from "../../theme.js";
import PreviewContext from "./PreviewContext";

export const Main = styled.main`
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
  ${color("white", "background-color")}
  box-shadow: 0px 5px 10px 0px #5e8472;
`;

const WithPreviewContext = ({ children }) =>
	<Grommet theme={theme}>
		<GlobalStyles />
		<PreviewContext.Provider value={true}>
			<Main dir="rtl">
				{children}
			</Main>
		</PreviewContext.Provider>
	</Grommet>;

const PreviewLayout = ({ children }) => {
	const iframeRef = useRef(null);

	useLayoutEffect(() => {
		const iframe = document.querySelector('#nc-root iframe');
		const iframeHeadElem = iframe && iframe.contentDocument.head;
		iframeRef.current = iframeHeadElem;
	});

	return iframeRef && iframeRef.current ?
		<StyleSheetManager target={iframeRef.current}>
			<WithPreviewContext>
				{children}
			</WithPreviewContext>
		</StyleSheetManager> :
		<WithPreviewContext >
			{children}
		</WithPreviewContext>;
};

export default PreviewLayout;
